import { render, staticRenderFns } from "./eventDetail.vue?vue&type=template&id=60b05b2a&scoped=true&"
import script from "./eventDetail.vue?vue&type=script&lang=ts&"
export * from "./eventDetail.vue?vue&type=script&lang=ts&"
import style0 from "./eventDetail.vue?vue&type=style&index=0&id=60b05b2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b05b2a",
  null
  
)

export default component.exports